<template>
    <v-layout>
        <v-flex xs12 v-if="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex xs12 v-if="!loading">
            <v-card>
                <v-card-title class="headline primary white--text">
                    {{ 'Rules'|translate }}
                </v-card-title>
                <v-card-actions>
                     <span style="width:300px;"><v-text-field class="ml-2" clearable v-model="search" type="text"
                                                              :label="'Keyword filter'|translate"></v-text-field></span>
                    <v-spacer></v-spacer>
                    <v-btn class="accent" @click="uploadDialogSwitch = true" :disabled="!$can('update', 'Rule')">
                        <v-icon small class="mr-2">fa-file-excel</v-icon>
                        {{ 'Bulk Upload Excel'|translate }}
                    </v-btn>
                    <v-btn class="accent" @click="exportPoints" :disabled="!rules||rules.lenth===0">
                        <v-icon small class="mr-2">fa-download</v-icon>
                        {{ 'Download'|translate }}
                    </v-btn>
                    <v-btn class="accent" v-if="hasSiteConfigMaster&&!syncInProgress" @click="importFromSiteConfigMaster()">
                        <v-icon small class="mr-2">fa-sitemap</v-icon>
                        {{ 'Sync with master'|translate }}
                    </v-btn>
                    <v-progress-circular indeterminate class="mr-5 ml-5" v-if="syncInProgress" size="18"></v-progress-circular>
                    <v-btn class="accent" @click="runAutoDiag"
                           :disabled="!rules||rules.lenth===0||!$can('update', 'Rule')">
                        <v-icon small class="mr-2">fa-cog</v-icon>
                        {{ 'Auto-diagnose'|translate }}
                    </v-btn>
                    <v-btn class="accent mr-2" @click="editedItem=null;dialog=true" :disabled="!$can('update', 'Rule')">
                        <v-icon class="mr-2" small>fa-plus</v-icon>
                        {{ 'Add Record'|translate }}
                    </v-btn>
                    <rule-record-dialog v-model="dialog" :item="editedItem" :parameter="parameter"
                                        v-on:doreload="refresh()"
                                        v-on:refreshpoints="refreshpoints()"></rule-record-dialog>
                    <maintenance-upload-dialog
                        v-model="uploadDialogSwitch"
                        v-if="uploadDialogSwitch"
                        endpoint="/rule/upload/"
                        has-remove-switch
                        v-on:doreload="refresh()"
                        title="Rule Creation">
                    </maintenance-upload-dialog>
                    <v-dialog v-model="dialog2" max-width="1000" persistent>
                        <v-card>
                            <v-card-title class="primary white--text title">
                                {{ 'Auto-diagnosing rules'|translate }}
                            </v-card-title>
                            <v-card-text>
                                <v-progress-linear v-if="!dialog2done" v-model="dialog2progress"></v-progress-linear>
                                <p v-if="dialog2done" class="pa-2">
                                    Diagnostic completed. {{dialog2disabled}} rules disabled.
                                </p>
                                <v-data-table v-if="dialog2done&&dialog2disabled>0"
                                    :headers="diagHeaders"
                                    :items="diagResult"
                                    class="elevation-1"
                                    :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                                    :items-per-page="25"
                                >
                                    <template v-slot:items="props">
                                        <td>{{ props.item.title }}</td>
                                        <td>{{ props.item.equipment_group }}</td>
                                        <td class="text-xs-left">
                                            <ul v-if="props.item.missingSensors">
                                                <li v-for="sensor in props.item.missingSensors">{{sensor}}</li>
                                            </ul>
                                        </td>
                                    </template>
                                </v-data-table>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn @click="dialog2=false" v-if="dialog2done">{{ 'Done'|translate }}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-card-actions>

                <v-card-text>
                    <v-data-table
                        :headers="headers"
                        :items="rules"
                        class="elevation-1"
                        :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                        :items-per-page="25"
                        :search="search2"
                    >
                        <template v-slot:items="props">
                            <td>{{ props.item.title }}</td>
                            <td>{{ props.item.desc }}</td>
                            <td class="text-xs-left">{{ props.item.equipment_group }}</td>
                            <td class="text-xs-left">

                                <span v-if="props.item.on">{{ 'Equipment On'|translate }}</span>
                                <span v-if="props.item.on===false">{{ 'Equipment Off'|translate }}</span>
                                <span v-if="props.item.on===null">{{ 'Anytime'|translate }}</span>
                            </td>
                            <td class="text-xs-left">{{ props.item.topic }}</td>
                            <td class="text-xs-left">
                                <span
                                    v-if="!props.item.active_status||props.item.active_status=='active'">{{
                                        'Active'|translate
                                    }}</span>
                                <span v-if="props.item.active_status=='inactive'">{{ 'Inactive'|translate }}</span>
                                <span v-if="props.item.active_status=='muted'">{{ 'Muted'|translate }}</span>

                            </td>
                            <td class="text-xs-left">{{ props.item.rule }}</td>
                            <td class="text-xs-left">{{ props.item.value }}</td>
                            <td class="text-xs-left">{{ props.item.cost }}</td>
                            <td class="justify-center">
                                <v-icon
                                    small
                                    class="mr-2"
                                    v-if="$can('update', 'Rule')"
                                    @click="$can('update', 'Rule') && editItem(props.item)"
                                >
                                    fa-edit
                                </v-icon>
                                <v-icon
                                    small
                                    v-if="$can('update', 'Rule')"
                                    @click="$can('update', 'Rule') &&  deleteItem(props.item)"
                                >
                                    fa-trash
                                </v-icon>
                            </td>
                        </template>
                        <template v-slot:no-data>
                            <v-btn color="primary" @click="initialize">{{ 'Reset'|translate }}</v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {
    getRule,
    deleteRule,
    getParameter,
    putRule,
    getFacilityList,
} from '../helper'
import RuleRecordDialog from '../components/rule/RuleRecordDialog'
import MaintenanceUploadDialog from "../components/maintenance/MaintenanceUploadDialog";
import {exportCSV} from '../tocsv'
import _ from "lodash";
import {mapGetters, mapActions} from 'vuex'

export default {
    name: 'Rules',
    components: {RuleRecordDialog, MaintenanceUploadDialog},
    data() {
        return {
            dialog: false,
            dialog2: false,
            dialog2progress: 0,
            dialog2done: 0,
            dialog2disabled: 0,
            loading: true,
            syncInProgress:false,
            uploadDialogSwitch: false,
            headers: [
                {
                    text: this.$options.filters.translate('Title'),
                    align: 'left',
                    sortable: true,
                    value: 'title'
                }, {
                    text: this.$options.filters.translate('Description'),
                    align: 'left',
                    sortable: true,
                    value: 'desc'
                },
                {text: this.$options.filters.translate('Applicable Group(s)'), value: 'equipment_group'},
                {text: this.$options.filters.translate('Rule Active when'), value: 'on'},
                {text: this.$options.filters.translate('Topic'), value: 'topic', sortable: true},
                {text: this.$options.filters.translate('Active Status'), value: 'active_status', sortable: true},
                {text: this.$options.filters.translate('Rule'), value: 'rule', sortable: false},
                {text: this.$options.filters.translate('Value'), value: 'value', sortable: false},
                {text: this.$options.filters.translate('Cost'), value: 'cost', sortable: false},
                {text: this.$options.filters.translate('Actions'), sortable: false},
            ],
            diagHeaders: [
                {
                    text: this.$options.filters.translate('Title'),
                    align: 'left',
                    sortable: true,
                    value: 'title'
                },
                {text: this.$options.filters.translate('Applicable Group(s)'), value: 'equipment_group'},
                {text: this.$options.filters.translate('Missing Sensors'), value: 'missingSensors', sortable: false},
            ],
            diagResult:[],
            parameter: [],
            rules: [],
            editedItem: {},
            search: '',
            search2: ''
        }
    },
    computed: {
        ...mapGetters([
             'siteConfigMaster',
        ]),
        hasSiteConfigMaster() {
            if (!this.siteConfigMaster){
                return false
            }
            if (this.$store.state.userStore.user) {
                if (process.env.VUE_APP_EXTERNAL_AUTH&&process.env.VUE_APP_EXTERNAL_AUTH==="msal"&&this.$store.state.userStore.user.content.role==="admin"){
                    return true
                } else if (process.env.VUE_APP_SUPERUSER&&process.env.VUE_APP_SUPERUSER!==""){
                    return this.$store.state.userStore.user.content.user_name.toLowerCase().includes(process.env.VUE_APP_SUPERUSER)
                } else {
                    return this.$store.state.userStore.user.content.user_name === "jecdavid" || this.$store.state.userStore.user.content.user_name.toLowerCase().includes("carnot")
                }
            }
            return false;
        },
    },
    watch: {
        search() {
            this.debounce(this.syncSearches, 500);
        }
    },
    mounted() {
        this.initialize()
    },
    methods: {
        async importFromSiteConfigMaster() {
            if (confirm('All rules will be imported from the master site. Any rules with the same ID will be replaced. This action cannot be reverted. Are you sure you wish to proceed ?')) {
                this.syncInProgress=true
                let remoteFacilities = await getFacilityList(
                    {
                        apiBaseUrl: this.siteConfigMaster
                    }
                )
                let remoteRules = await getRule(
                    {
                        apiBaseUrl: this.siteConfigMaster,
                        facility_name:remoteFacilities.facilities[0].facility_name
                    }
                )
                for (let rule  of remoteRules.result){
                    delete (rule.facility_id)
                    rule.facility_name = this.$store.state.pointsListStore.pointsList.facility_name
                    await putRule(rule)
                }
                this.syncInProgress=false
                await this.refresh()
            }
        },
        async initialize() {
            await this.refresh()
            let title = _.get(this.$route.query, 'title', null)
            let equipment_type = _.get(this.$route.query, 'equipment_type', null)
            if (title && equipment_type) {
                let found = this.rules.filter(x => x.title === title && x.equipment_group === equipment_type)
                if (found && found.length > 0) {
                    this.editItem(found[0])
                }
            }
        },
        editItem(item) {
            this.editedItem = JSON.parse(JSON.stringify(item))
            this.dialog = true
        },

        async deleteItem(item) {
            if (confirm(this.$options.filters.translate('Are you sure you want to delete this item?'))) {
                await deleteRule({
                    'rule_id': item.rule_id
                })
                this.refresh()
            }
        },
        async runAutoDiag() {
            if (confirm(this.$options.filters.translate('This will disable all rules which lack the required variables. Are you sure you want to run auto-diagnostic?'))) {
                let total = this.rules.length
                let current = 0
                this.dialog2progress = 0
                this.dialog2done=false
                this.dialog2disabled = 0
                this.diagResult= []
                let diagResult=[]
                this.dialog2 = true
                let combinations = JSON.parse(JSON.stringify(this.$store.state.pointsListStore.pointsList.points_list.map(sensor => {
                    return {
                        sensor_name: sensor.sensor_name,
                        equipment_name: sensor.equipment_name,
                        equipment_type: this.$store.state.pointsListStore.pointsList.equipment_details[sensor.equipment_name].equipment_type,
                    }
                })))
                for (let rule of this.rules) {
                    if (!rule.active_status||rule.active_status==="active") {
                        let isOK = true
                        let borkedRule= null
                        let sensorsForType = combinations.filter(x => x.equipment_type === rule.equipment_group).map(x => x.sensor_name)
                        if (rule.relevant_variables && rule.relevant_variables !== "") {
                            let relVars = rule.relevant_variables.split(",")
                            let tbr=rule.rule.match(/df\["(.*?)"\]/g)
                            if (tbr){
                                for (let item of tbr){
                                    let itemCenter=item.split('"')[1]
                                    if(itemCenter){
                                        relVars.push(itemCenter)
                                    }
                                }
                            }
                            relVars=JSON.parse(JSON.stringify([...new Set(relVars)]))
                            for (let relVar of relVars) {
                                if (!sensorsForType.includes(relVar)) {
                                    console.log("No sensor named "+relVar+" for equipments of type "+rule.equipment_group)
                                    isOK = false
                                    if(!borkedRule){
                                        borkedRule={
                                            title:rule.title,
                                            equipment_group:rule.equipment_group,
                                            missingSensors:[]
                                        }
                                    }
                                    borkedRule.missingSensors.push(relVar)
                                }
                            }
                        }
                        if (!isOK){
                            rule.active_status="inactive"
                            rule.facility_name=this.$store.state.pointsListStore.pointsList.facility_name
                            await putRule(rule)
                            this.dialog2disabled=this.dialog2disabled+1
                            diagResult.push(borkedRule)
                        }
                    }
                    current = current + 1
                    this.dialog2progress = 100 * current / total
                }
                this.diagResult=diagResult
                this.dialog2done=true
                this.refresh()
            }
        },
        async refreshpoints() {
            let dfp = await getParameter({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name
            })
            this.parameter = dfp['result']
        },
        async refresh() {
            let df = await getRule({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
            })
            let dfp = await getParameter({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name
            })
            this.rules = df['result']
            this.parameter = dfp['result']
            this.loading = false
            this.dialog = false
        },
        syncSearches() {
            this.search2 = this.search
        },
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => callback(), wait);
        },
        exportPoints() {
            let cleanedItems = JSON.parse(JSON.stringify(this.rules))
            exportCSV(cleanedItems.map(item => {
                return {
                    desc: item.desc,
                    equipment_group: item.equipment_group,
                    rule: item.rule,
                    on: item.on,
                    value: item.value,
                    cost: item.cost,
                    severity: item.severity,
                    title: item.title,
                    relevant_variables: item.relevant_variables,
                    recommended_actions: item.recommended_actions,
                    topic: item.topic,
                    active_status: item.active_status,
                    meta: item.meta ? JSON.stringify(item.meta) : "",
                }
            }))
        },
    }
}
</script>

<style scoped>

</style>
